import React from 'react';

// loading the sass style fot the component
import css from './styles.module.scss';

/**
 * Atom FormInput
 *
 * <!-- TODO: add a description here! -->
 */
function FormInput(props) {

  const {
    className = '',
    id,
    disabled,
    label,
    masking,
    dataRegister,
    dataErrors,
    displayLabel = true,
    displayError = true,
    ...other
  } = props;

  const onChangeCalls = (e) => {
    masking && masking(e);
    dataRegister.onChange(e);
  };

  return (
    <div className={`${css['atom__form-input-container']} ${css['ff-container']} ${className}`}>
      <label
        htmlFor={id}
        className={`${css['ff-label']} ${disabled ? css['ff-disabled'] : ''} ${displayLabel ? '' : css['absent']}`}
      >
        {label}
      </label>
      <input
        id={id}
        data-testid="formInputControl"
        className={`${displayError ? css['ff-box'] : css['ff-box-clean']} ${css['field-input']} ${
          dataErrors?.type ? css['ff-box-error'] : ''
        }`}
        {...dataRegister}
        {...other}
        onChange={onChangeCalls}
        disabled={disabled ? true : undefined}
      ></input>
      {displayError && dataErrors?.type && <span className={css['ff-error-message']}>{dataErrors.message}</span>}
    </div>
  );
}

export default FormInput;
